<script setup lang="ts">
import DocumentationButton from "@/components/header/DocumentationButton.vue";
</script>

<template>
  <v-app-bar class="pa-0" height="36" app fixed dark v-bind="$attrs">
    <v-toolbar v-bind="$attrs" density="compact" color="primary" style="width: 100%">
      <div
        class="d-flex justify-center align-center"
        style="position: absolute; left: 50%; transform: translateX(-50%)"
      >
        <div class="d-flex justify-center align-center">
          <v-toolbar-title class="text-onPrimary">Haskoning</v-toolbar-title>
        </div>
      </div>
      <v-spacer />
      <DocumentationButton />
    </v-toolbar>
  </v-app-bar>
</template>
